import { NgModule } from '@angular/core';
import { CoreModule } from '@core/core.module';
import { AuthRoutingModule } from './auth-routing.module';


@NgModule({
    imports: [
        AuthRoutingModule,
        CoreModule,
    ],
})
export class AuthModule {
}
